import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiError, MessageService } from '../../../../../core';
import { ClienteFilter } from '../../filter';
import { ClienteChartHttpService } from '../services';
import { ClienteSegmentoChart } from './cliente-segmento-chart';

@Component({
    selector: 'sgt-cliente-segmento-chart',
    templateUrl: './cliente-segmento-chart.component.html',
    styleUrls: ['./cliente-segmento-chart.component.less']
})
export class ClienteSegmentoChartComponent {
    title = 'Segmentos';
    currentRequest: Subscription;
    isLoading: boolean;
    chart: ClienteSegmentoChart;


    constructor(private messageService: MessageService,
                private clienteChartHttpService: ClienteChartHttpService) { }


    load(filter: ClienteFilter) {
        this.showLoading();
        this.chart = null;
        this.currentRequest?.unsubscribe();
        this.currentRequest = this.clienteChartHttpService.loadSegmento(filter)
            .subscribe(
                chart => {
                    this.chart = chart;
                    this.show();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao carregar o gráfico de segmentos dos clientes', error),
                () => this.hideLoading()
            );
    }


    private showLoading() {
        this.isLoading = true;
    }

    private hideLoading() {
        this.isLoading = false;
    }

    private show() {

    }
}
